import BaseRepository from "../pages/repository";
import queryByKeys from "@/services/resources/mixins/query-by-keys";
import Kernel from "@oilstone/kernel";

class Repository extends BaseRepository {
    static make(model, schema) {
        return new Repository(model, schema).$mix(queryByKeys);
    }

    listing() {
        const citations = Kernel.resolve('resourceRegistry').find('citations').repository.withSpecialisationsAndPeople().then(collection => {
            return collection.map(record => {
                return {
                    type: 'citations',
                    resource: record
                }
            });
        });

        return Promise.all([
            citations
        ]).then(collections => {
            return [].concat(...collections);
        });
    }
}

export default Repository;
